"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Promise = void 0;
var Promise = window.Promise;
exports.Promise = Promise;

if (window.hubspot && typeof window.hubspot.require === 'function') {
  window.hubspot.require(['q'], function (Q) {
    exports.Promise = Promise = Q.Promise;
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.227/js/helpers/promise.js
// module id = 202
// module chunks = 5 6